import React, { createContext, useContext, useState, useCallback } from 'react';
import { THEMES, getSavedTheme, applyTheme } from '../styles/themes';

const ThemeContext = createContext({ themeId: 'xuanye', themes: THEMES, setTheme: () => {} });

export const ThemeProvider = ({ children }) => {
  const [themeId, setThemeId] = useState(getSavedTheme);

  const setTheme = useCallback((id) => {
    applyTheme(id);
    setThemeId(id);
  }, []);

  return (
    <ThemeContext.Provider value={{ themeId, themes: THEMES, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
